import React, {ReactNode} from 'react';
import {
  Image,
  ImageRequireSource,
  Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';

import NoImage from '../images/LMG_IMAGE_NOT_AVAILABLE.jpg';

type HorizontalTileProps = {
  content: ReactNode;
  imageSource?: ImageRequireSource;
  imageUri?: string;
  onPress?: (item: any) => void;
  testID: string;
};

const HorizontalTile = ({content, imageSource, imageUri, onPress, testID}: HorizontalTileProps) => (
  <TouchableOpacity onPress={onPress} style={styles.item} testID={testID}>
    <View style={styles.itemInside}>
      <View style={styles.leftCol}>
        {imageUri || imageSource ? (
          <Image
            source={imageSource ? imageSource : {uri: imageUri}}
            style={styles.tileImage}
            resizeMode="contain"
          />
        ) : (
          <Image
            source={NoImage}
            style={styles.tileImage}
            resizeMode="contain"
            width={null}
            height={null}
          />
        )}
      </View>
      <View style={styles.rightCol}>{content}</View>
    </View>
  </TouchableOpacity>
);

export default HorizontalTile;

const styles = StyleSheet.create({
  leftCol: {
    flex: 1,
    marginVertical: 1,
    justifyContent: 'center',
  },
  tileImage: {
    width: '100%',
    aspectRatio: 1,
    marginVertical: 4,
  },
  item: {
    borderWidth: 0.5,
    borderColor: 'grey',
    borderRadius: 4,
    paddingLeft: 4,
    backgroundColor: 'white',
    marginHorizontal: 8,
    ...Platform.select({web: {minHeight: 100}}),
  },
  itemInside: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  rightCol: {
    flex: 4,
    paddingHorizontal: 12,
    paddingVertical: 4,
    alignSelf: 'stretch',
    justifyContent: 'space-between',
  },
});
